import { Flex } from "@chakra-ui/react";
import RecordTargetTag from "features/RecordTarget/RecordTargetTag";
import { MessageTemplate } from "features/Resources/MessageTemplate/models";
import DisplayResourceTargetsColumn from "features/Resources/SharedTemplate/Components/DisplayResourceTargetsColumn";
import ResourceTargetAvatar from "features/Resources/SharedTemplate/Components/ResourceTargetAvatar";
import useTargetName from "hooks/useTargetName";
import { RecordTarget } from "features/RecordTarget/models";

function MessageTemplateRecipientAvatar({ recipient }: { recipient: RecordTarget }) {
  const { name, role } = useTargetName({
    resourceId: recipient.targetId,
    resourceType: recipient.targetType,
  });
  return <ResourceTargetAvatar name={name || ""} roleName={role} />;
}

export function DisplayRecipients({ messageTemplate }: { messageTemplate: MessageTemplate }) {
  if (!messageTemplate?.recipient) {
    return null;
  }

  return (
    <Flex align="center" gap="1">
      <DisplayResourceTargetsColumn<RecordTarget>
        items={[messageTemplate.recipient]}
        renderTag={(recipient: RecordTarget) => (
          <RecordTargetTag key={recipient.targetId} recordTarget={recipient} disabled />
        )}
        renderAvatar={(recipient: RecordTarget) => <MessageTemplateRecipientAvatar recipient={recipient} />}
        getKey={(recipient: RecordTarget) => recipient.targetId}
        emptyLabel="No Recipients"
      />
    </Flex>
  );
}
